import { ApiInstance } from '../..';
import { SearchQueryParams } from '../../../interface/paging';
import { TUsers } from '../../../pages/users/type';
import { convert2QueryString } from '../../../utils/convert2QueryString';

export const getUsers = (params: SearchQueryParams | undefined) => {
    const requestURL = '/api/user?' + convert2QueryString(params);
    return ApiInstance.getInstance().get(requestURL);
};

export const createUser = (data: TUsers) => {
    return ApiInstance.getInstance().post('/api/user', data);
};

export const updateUser = (
    userId: string | undefined | number,
    data: TUsers
) => {
    const baseUrl = `/api/user/${userId}`;
    return ApiInstance.getInstance().put(baseUrl, data);
};

export const deleteUser = (userId: string | undefined | number) => {
    const baseUrl = `/api/user/${userId}`;
    return ApiInstance.getInstance().delete(baseUrl);
};
